import React from 'react';
import { Redirect } from 'react-router-dom';

const InstallmentReconciliation = React.lazy(() => import('pages/Orders/pages/InstallmentReconciliationPage'));
const Orders = React.lazy(() => import('pages/Orders/pages/OrdersPage'));
const WebsiteOrders = () => <Redirect to='/orders/preorder' />;
const PreOrderOrders = React.lazy(() => import('pages/Orders/pages/PreOrderOrdersPage'));
const OrdersAdd = React.lazy(() => import('pages/Orders/pages/OrdersAdd'));
const OrdersEdit = React.lazy(() => import('pages/Orders/pages/OrdersEdit'));
const OrdersDetail = React.lazy(() => import('pages/Orders/pages/OrdersDetail'));
const OrdersPayment = React.lazy(() => import('pages/Orders/pages/OrdersPayment'));
const OrderDelivery = React.lazy(() => import('pages/OrderDelivery/pages/OrderDeliveryPage'));
const OrderDeliveryCodReconciliation = React.lazy(() =>
  import('pages/OrderDelivery/pages/OrderDeliveryCodReconciliationPage'),
);
const ProductPriceInventory = React.lazy(() => import('pages/ProductPriceInventory/ProductPriceInventoryPage'));
const ProductPriceInventoryDetail = React.lazy(() => import('pages/ProductPriceInventory/ProductPriceInventoryDetailPage'));
const WarrantyManagement = React.lazy(() => import('pages/WarrantyManagement/WarrantyManagementPage'));
const ServiceWorkOrderList = React.lazy(() => import('pages/ServiceWorkOrder/ServiceWorkOrderListPage'));
const ServiceWorkOrderForm = React.lazy(() => import('pages/ServiceWorkOrder/ServiceWorkOrderFormPage'));

const orders = [
  { path: '/warranty-receiving', exact: true, name: 'Nhận hàng bảo hành', function: 'SL_WARRANTY_MANAGEMENT_VIEW', component: WarrantyManagement },
  { path: '/warranty-stock-out', exact: true, name: 'Xuất kho bảo hành', function: 'SL_WARRANTY_MANAGEMENT_VIEW', component: WarrantyManagement },
  { path: '/warranty-stock-in', exact: true, name: 'Nhập kho bảo hành', function: 'SL_WARRANTY_MANAGEMENT_VIEW', component: WarrantyManagement },
  { path: '/warranty-transfers', exact: true, name: 'Chuyển kho bảo hành', function: 'SL_WARRANTY_MANAGEMENT_VIEW', component: WarrantyManagement },
  { path: '/warranty-receipts', exact: true, name: 'Phiếu thu bảo hành', function: 'SL_WARRANTY_MANAGEMENT_FINANCE', component: WarrantyManagement },
  { path: '/warranty-payments', exact: true, name: 'Phiếu chi bảo hành', function: 'SL_WARRANTY_MANAGEMENT_FINANCE', component: WarrantyManagement },
  { path: '/warranty-reconciliation', exact: true, name: 'Đối soát công nợ bảo hành', function: 'SL_WARRANTY_MANAGEMENT_FINANCE', component: WarrantyManagement },
  { path: '/warranty-stock-documents', exact: true, name: 'Chứng từ bảo hành', function: 'SL_WARRANTY_MANAGEMENT_VIEW', component: WarrantyManagement },
  {path:'/orders/website',exact:true,name:'Đơn từ website',function:'SL_ORDER_VIEW',component:WebsiteOrders},
  {path:'/installment-reconciliation',exact:true,name:'Đối soát trả góp',function:'SL_RECEIVE_PAYMENT_CREDIT_VIEW',component:InstallmentReconciliation},
  {
    path: '/orders',
    exact: true,
    name: 'Danh sách đơn hàng',
    function: 'SL_ORDER_VIEW',
    component: Orders,
  },
  {
    path: '/orders/preorder',
    exact: true,
    name: 'Danh sách đơn hàng đặt',
    function: 'SL_ORDER_VIEW',
    component: PreOrderOrders,
  },
  {
    path: '/orders/add',
    exact: true,
    name: 'Thêm mới đơn hàng',
    function: 'SL_ORDER_ADD',
    component: OrdersAdd,
  },
  {
    path: '/orders/edit/:id',
    exact: true,
    name: 'Chỉnh sửa đơn hàng',
    function: 'SL_ORDER_EDIT',
    component: OrdersEdit,
  },
  {
    path: '/orders/detail/:id',
    exact: true,
    name: 'Chi tiết đơn hàng',
    function: 'SL_ORDER_VIEW',
    component: OrdersDetail,
  },
  {
    path: '/orders/payment/:order_id',
    exact: true,
    name: 'Thông tin thanh toán đơn hàng',
    function: 'SL_ORDER_EDIT',
    component: OrdersPayment,
  },
  {
    path: '/order-delivery',
    exact: true,
    name: 'Quản lý giao hàng',
    function: 'SL_ORDER_DELIVERY_ASSIGNED_VIEW',
    component: OrderDelivery,
  },
  {
    path: '/order-delivery/cod-reconciliation',
    exact: true,
    name: 'Đối soát COD đơn vị vận chuyển',
    function: 'SL_ORDER_EDIT',
    component: OrderDeliveryCodReconciliation,
  },
  {
    path: '/product-price-inventory/detail/:id',
    exact: true,
    name: 'Chi tiết giá và tồn kho',
    function: 'ST_PRODUCT_PRICE_INVENTORY_VIEW',
    component: ProductPriceInventoryDetail,
  },
  {
    path: '/product-price-inventory',
    exact: true,
    name: 'Thông tin giá, tồn kho và bảo hành',
    function: 'ST_PRODUCT_PRICE_INVENTORY_VIEW',
    component: ProductPriceInventory,
  },
  {
    path: '/warranty-work-orders',
    exact: true,
    name: 'Lệnh sửa chữa & bảo hành',
    function: 'SL_SERVICE_WORK_ORDER_VIEW',
    component: ServiceWorkOrderList,
  },
  {
    path: '/warranty-work-orders/add',
    exact: true,
    name: 'Lập lệnh sửa chữa',
    function: 'SL_SERVICE_WORK_ORDER_ADD',
    component: ServiceWorkOrderForm,
  },
  {
    path: '/warranty-work-orders/detail/:id',
    exact: true,
    name: 'Chi tiết lệnh sửa chữa',
    function: 'SL_SERVICE_WORK_ORDER_VIEW',
    component: ServiceWorkOrderForm,
  },
  {
    path: '/warranty-work-orders/edit/:id',
    exact: true,
    name: 'Chỉnh sửa lệnh sửa chữa',
    function: 'SL_SERVICE_WORK_ORDER_EDIT',
    component: ServiceWorkOrderForm,
  },
  {
    path: '/warranty-intake/add',
    exact: true,
    name: 'Tạo phiếu tiếp nhận bảo hành',
    function: 'SL_WARRANTY_MANAGEMENT_ADD',
    component: WarrantyManagement,
  },
  {
    path: '/warranty-intake',
    exact: true,
    name: 'Tra cứu & tiếp nhận bảo hành',
    function: 'SL_WARRANTY_MANAGEMENT_VIEW',
    component: WarrantyManagement,
  },
  {
    path: '/warranty-repairs/detail/:requestId',
    exact: true,
    name: 'Chi tiết phiếu sửa chữa bảo hành',
    function: 'SL_WARRANTY_MANAGEMENT_VIEW',
    component: WarrantyManagement,
  },
  {
    path: '/warranty-repairs',
    exact: true,
    name: 'Quản lý sửa chữa bảo hành',
    function: 'SL_WARRANTY_MANAGEMENT_VIEW',
    component: WarrantyManagement,
  },
  {
    path: '/warranty-products',
    exact: true,
    name: 'Sản phẩm đã bán & bảo hành',
    function: 'SL_WARRANTY_MANAGEMENT_VIEW',
    component: WarrantyManagement,
  },
  {
    path: '/warranty-manufacturer',
    exact: true,
    name: 'Bảo hành gửi hãng',
    function: 'SL_WARRANTY_MANAGEMENT_VIEW',
    component: WarrantyManagement,
  },
  {
    path: '/warranty-management',
    exact: true,
    name: 'Tra cứu & tiếp nhận bảo hành',
    function: 'SL_WARRANTY_MANAGEMENT_VIEW',
    component: WarrantyManagement,
  },
];

export default orders;
